/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { paymentResponseSchema } from "./paymentResponseSchema.ts";

export const orderPaymentSchema = paymentResponseSchema.describe("Сериализатор платежа внутри заказа.");
